<template>
  <v-data-iterator :items="feeds" hide-actions>
    <template v-slot:item="feed">
      <v-subheader>{{ feed.item.name }}</v-subheader>
      <v-data-table :headers="headers" :items="feed.item.logs" hide-actions>
        <template v-slot:items="log">
          <td>{{ log.item.notification_time }}</td>
          <td>{{ log.item.location }}</td>
          <td>{{ log.item.code }}</td>
          <td>
            <v-icon
              v-if="log.item.isLatest"
              v-bind:class="{
                'green--text': log.item.isSuccess,
                'orange--text': !log.item.isSuccess
              }"
              >event_note</v-icon
            >
            {{ log.item.message }}
          </td>
        </template>
      </v-data-table>
      <v-divider />
    </template>
  </v-data-iterator>
</template>

<script>
export default {
  props: ["headers", "feeds"]
};
</script>
